import { createAsyncThunk } from '@reduxjs/toolkit';
import { getQuote, emailQuote } from 'shared/api/apiQuote';

export const doQuote = createAsyncThunk(
  'fabrication/doQuote',
  (_args, thunkAPI) => {
    const state = thunkAPI.getState().fabrication;
    const { parameters, currentVariant: variant } = state;

    const token = document.getElementsByName('authenticity_token')[0].value;

    const data = { ...parameters };
    if (data.quantities) {
      data.quantities = data.quantities.map((q) => q.toString());
    }

    const promise = getQuote({
      data,
      token,
      variant,
      quoteNumber: parameters.product_quote_number,
    });

    return promise
      .then((res) => res.data)
      .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
  },
);

export const doEmailQuote = createAsyncThunk(
  'fabrication/doEmailQuote',
  (args, thunkAPI) => {
    const token = document.getElementsByName('authenticity_token')[0].value;
    const { data } = args;

    const promise = emailQuote({ data, token });

    return promise
      .then((res) => res.data)
      .catch((error) => thunkAPI.rejectWithValue({ error: error.message }));
  },
);
